var _g, _path, _rect, _rect2, _rect3, _g2, _path2, _rect4, _rect5, _rect6, _g3, _rect7, _rect8, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerFilesRigth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 120,
    viewBox: "0 0 220 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2447_13093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9531 11.9533C11.9531 8.65245 14.629 5.97662 17.9298 5.97662L50.0542 5.97662L62.5229 5.97662C64.1064 5.97662 65.6252 6.60505 66.7458 7.72391L86.4016 27.3496C87.5244 28.4707 88.1553 29.9923 88.1553 31.579V57.4803L88.1553 96C88.1553 99.3008 85.4795 101.977 82.1787 101.977H17.9298C14.629 101.977 11.9531 99.3008 11.9531 96L11.9531 11.9533Z",
    fill: "#B8D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9297 6.35065L62.5225 6.35065C64.0069 6.35065 65.4309 6.93951 66.4814 7.98834L86.1377 27.6143C87.1902 28.6653 87.7822 30.0917 87.7822 31.5792L87.7822 96.0001C87.7822 99.0945 85.2732 101.603 82.1787 101.603H17.9297C14.8352 101.603 12.3272 99.0945 12.3271 96.0001L12.3271 11.9532C12.3272 8.85874 14.8352 6.35069 17.9297 6.35065Z",
    stroke: "#8EB6FF",
    strokeWidth: 0.74708
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.502 30.4053L63.502 10.5771C63.502 9.91175 64.3061 9.5783 64.7769 10.0484L85.3837 30.6237C85.8549 31.0942 85.5217 31.8995 84.8559 31.8995H64.9961C64.1709 31.8995 63.502 31.2305 63.502 30.4053Z",
    fill: "#8EB6FF",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.7974,
    y: 43.4908,
    width: 40.3423,
    height: 2.05584,
    rx: 1.02792,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7974,
    y: 50.4908,
    width: 35.1128,
    height: 2.05584,
    rx: 1.02792,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7974,
    y: 57.5025,
    width: 47.0661,
    height: 2.05584,
    rx: 1.02792,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2447_13093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.852 11.9533C101.852 8.65245 104.527 5.97662 107.828 5.97662L139.953 5.97662L152.421 5.97662C154.005 5.97662 155.524 6.60505 156.644 7.72391L176.3 27.3496C177.423 28.4707 178.054 29.9923 178.054 31.579V57.4803V96C178.054 99.3008 175.378 101.977 172.077 101.977H107.828C104.527 101.977 101.852 99.3008 101.852 96V11.9533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.828 6.35065L152.421 6.35065C153.905 6.35065 155.329 6.93951 156.38 7.98834L176.036 27.6143C177.089 28.6653 177.681 30.0917 177.681 31.5792V96.0001C177.681 99.0945 175.172 101.603 172.077 101.603H107.828C104.734 101.603 102.226 99.0945 102.226 96.0001V11.9532C102.226 8.85874 104.734 6.35069 107.828 6.35065Z",
    stroke: "#4381E5",
    strokeWidth: 0.74708
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.4 30.4053V10.5771C153.4 9.91175 154.205 9.5783 154.675 10.0484L175.282 30.6237C175.753 31.0942 175.42 31.8995 174.754 31.8995H154.895C154.069 31.8995 153.4 31.2305 153.4 30.4053Z",
    fill: "#E1E8FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 109.32,
    y: 43.1172,
    width: 41.0894,
    height: 2.80292,
    rx: 1.40146,
    fill: "#EAEFFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 109.322,
    y: 50.1172,
    width: 35.8599,
    height: 2.80292,
    rx: 1.40146,
    fill: "#EAEFFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 109.322,
    y: 57.129,
    width: 47.8131,
    height: 2.80292,
    rx: 1.40146,
    fill: "#EAEFFB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2447_13093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.75 11.9533C191.75 8.65245 194.426 5.97662 197.727 5.97662L229.851 5.97662L242.32 5.97662C243.903 5.97662 245.422 6.60505 246.543 7.72391L266.198 27.3496C267.321 28.4707 267.952 29.9923 267.952 31.579V57.4803V96C267.952 99.3008 265.276 101.977 261.976 101.977H197.727C194.426 101.977 191.75 99.3008 191.75 96V11.9533Z",
    fill: "#8EB6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.727 6.35065L242.319 6.35065C243.804 6.35065 245.228 6.93951 246.278 7.98834L265.935 27.6143C266.987 28.6653 267.579 30.0917 267.579 31.5792V96.0001C267.579 99.0945 265.07 101.603 261.976 101.603H197.727C194.632 101.603 192.124 99.0945 192.124 96.0001V11.9532C192.124 8.85874 194.632 6.35069 197.727 6.35065Z",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 199.594,
    y: 43.4908,
    width: 40.3423,
    height: 2.05584,
    rx: 1.02792,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 199.594,
    y: 50.4908,
    width: 35.1128,
    height: 2.05584,
    rx: 1.02792,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 199.594,
    y: 57.5026,
    width: 47.0661,
    height: 2.05584,
    rx: 1.02792,
    fill: "#155EEF",
    stroke: "#5F94FF",
    strokeWidth: 0.74708
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2447_13093",
    x: -0.000159264,
    y: -0.0000185966,
    width: 100.11,
    height: 119.907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.97664
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.97664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_13093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_13093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2447_13093",
    x: 89.8983,
    y: -0.0000185966,
    width: 100.11,
    height: 119.907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.97664
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.97664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_13093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_13093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2447_13093",
    x: 179.797,
    y: -0.0000185966,
    width: 100.11,
    height: 119.907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.97664
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.97664
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_13093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_13093",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerFilesRigth);
export default __webpack_public_path__ + "static/media/banner-files-rigth.86bc3a866f0c5acca8c4cc945fad30d7.svg";
export { ForwardRef as ReactComponent };